export const smoothScrollTo = (href, headerHeight = 0) => {
	const id = href.substring(1, href.length);
	const target = document.querySelector(`[name="${id}"]`);

	if (!target) return;

	const offset = target.getBoundingClientRect().top + window.scrollY - headerHeight;

	window.scrollTo({ top: offset, behavior: "smooth" });
};
